import React, {useContext} from "react";
import {Text, Image, View} from '@react-pdf/renderer';
import PropTypes from "prop-types";

import {PrintDocumentContext} from "./printDocumentContext";

const PrintDocumentHeader = (props) => {
  const {styles, jobId, fabricatorData, printLogo} = props;

  const date = new Date();
  const printContext = useContext(PrintDocumentContext);

  const logoView = printLogo ? (
    <View style={fabricatorData.isAmericanStandard ? [styles.headerLogo, styles.headerLogoAS] : styles.headerLogo}>
      <Image style={styles.headerLogoImage} source={{ uri: printLogo, method: "GET", headers: { "Cache-Control": "no-cache" } }} />
    </View>
  ) : null;

  const jobInfoView = (
    <View style={styles.headerInfo}>
      {document.kvConfig.jobId || jobId ? (
        <View style={styles.headerText}>
          <Text style={styles.headerTextBold}>{printContext.messages["receipt.header.quoteNumber"]}</Text>
          <Text style={styles.headerTextValue}>{document.kvConfig.jobId || jobId}</Text>
        </View>
      ) : null}
      <View style={styles.headerText}>
        <Text style={styles.headerTextBold}>{printContext.messages["receipt.header.date"]}</Text>
        <Text style={styles.headerTextValue}>{date.toLocaleDateString().replace(/\//gi, "-")}</Text>
      </View>
      <View style={styles.headerText}>
        <Text style={styles.headerTextBold}>{printContext.messages["receipt.header.time"]}</Text>
        <Text style={styles.headerTextValue}>{date.toLocaleTimeString()}</Text>
      </View>
    </View>
  )

  if (fabricatorData.isAmericanStandard) {
    return (
      <View style={styles.specSheet} fixed={true}>
        <View style={styles.headerTextASSheet}>
          <Text style={styles.headerTextBold}>Specification Sheet</Text>
        </View>
        {logoView}
        <View style={styles.headerTextASInfo}>{jobInfoView}</View>
      </View>
    )
  }

  return (
    <View style={styles.header}>
      <View style={styles.headerTextASSheet}/>
      {logoView}
      <View style={styles.headerTextASInfo}>{jobInfoView}</View>
    </View>
  )
};

PrintDocumentHeader.propTypes = {
  fabricatorData: PropTypes.object,
  jobId: PropTypes.number,
  styles: PropTypes.object.isRequired,
  printLogo: PropTypes.string,
};

export default PrintDocumentHeader
